import React, { Component, useState, useRef, useEffect, useContext } from 'react'
import Tooltip from '@material-ui/core/Tooltip'
import { Link } from "react-router-dom";
// import StateContext from '../store/LanguageContext/LanguageContext.js'
import { CSSTransition } from 'react-transition-group'

// MUI material design
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Button from '@material-ui/core/Button'

import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

import LanguageSelector from '../store/LanguageContext/LanguageSelectorButton.js';

import { ReactComponent as ProfileIcon } from '../icons/profile.svg'
import { ReactComponent as MessengerIcon } from '../icons/messenger.svg'
import { ReactComponent as BellIcon } from '../icons/bell.svg'
import { ReactComponent as PlusIcon } from '../icons/plus.svg'
import { ReactComponent as CaretIcon } from '../icons/caret.svg'
import { ReactComponent as CogIcon } from '../icons/cog.svg'
import { ReactComponent as ChevronIcon } from '../icons/chevron.svg'
import { ReactComponent as ArrowIcon } from '../icons/arrow.svg'
import { ReactComponent as BoltIcon } from '../icons/bolt.svg'

import { useLocation } from 'react-router-dom'

var open = null, setOpen = null, isMobile = null

function Navbar() {

  // 
  // const context = useContext(StateContext)

  // const [language] = React.useState(context)
  // console.log(`language`, context)
  const [anchorEl, setAnchorEl] = React.useState(null);
  const openMenu = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  
  [open,setOpen] = useState(false)
  [isMobile] = useState(window.innerWidth < 550)

  useEffect( () => {
    // console.log('mounting?', document.body)
    document.body.addEventListener('click', closeDropdown)
    window.onresize = () => {
      isMobile = window.innerWidth < 550
    }

  },[])

  // function toggleLanguage() {
  //   
  //   if (context.language == 'pt') {
  //     context.defineLanguage('en')
  //   } else {
  //     context.defineLanguage('pt')
  //   }
  // }

  function closeDropdown(event) {
    
    let isCaretButton = false
    event.path.forEach(el => {if (el.id === 'faceLikeDrop') {isCaretButton = true}})
    if (!isCaretButton && open) {
      setOpen(open = false)
    }
  }
  // this.setState({ isMobile: window.innerWidth < 550 });


  const location = useLocation()
  let facebookNav = null;


    if (location.pathname === '/') {
      if (!isMobile) {
        facebookNav =
        <div id="facebook-like-nav-buttons">
          <Tooltip title="Click the arrow to show dropdown menu">
            <nav className="navbar">
              <ul className="navbar-nav">
              <LanguageSelector />
                {/* <StateContext.Consumer value={this.context}> */}
                  {/* <button onClick={toggleLanguage}> change language </button> */}
                {/* </StateContext.Consumer> */}
                <Navitem icon="😡" />
                <Navitem icon="😵" />
                <Navitem icon="🤑" />
                <Navitem icon="😾" />
                <Navitem icon="✨⚡" />
                <Navitem icon={<PlusIcon />} />
                <Navitem icon={<BellIcon />} />
                <Navitem icon={<MessengerIcon />} />
                <Navitem id="faceLikeDrop" icon={<CaretIcon />}>
                  <DropdownMenu></DropdownMenu>
                </Navitem>
              </ul>
            </nav>
          </Tooltip>
        </div>
      } else {
        facebookNav =
        <div id="facebook-like-nav-buttons">
          <Tooltip title="Click the arrow to show dropdown menu">
            <nav className="navbar">
              <ul className="navbar-nav">
                <Navitem icon="🤑" />
                <Navitem icon="😾" />
                <Navitem icon="🖕" />
                <Navitem icon={<MessengerIcon />} />
                <Navitem id="faceLikeDrop" icon={<CaretIcon />}>
                  <DropdownMenu></DropdownMenu>
                </Navitem>
              </ul>
            </nav>
          </Tooltip>
        </div>
      }
    }
    return (
      <AppBar>
        <Toolbar className="nav-container">
          <div id="router-buttons">
            <Button color="inherit" component={Link} to="/">
              Home
            </Button>
            <Button color="inherit" component={Link} to="/tic-tac-toe">
              TIC-TAC-TOE
            </Button>
            <Button color="inherit" component={Link} to="/day-three">
              Day three
            </Button>
            <Button color="inherit" component={Link} to="/conditional-rendering-in-react">
              Conditional Rendering
            </Button>
            {/* <Button color="inherit" component={Link} to="/3d-world">
              ThreeJs 3d world
            </Button> */}
            <Button color="inherit" component={Link} to="/jsx-in-depth">
              Jsx in depth
            </Button>
            <Button
              id="basic-button"
              aria-controls="basic-menu"
              aria-haspopup="true"
              aria-expanded={openMenu ? 'true' : undefined}
              onClick={handleClick}
              style={{color: 'white'}}
            >
              Threejs 3D World
            </Button>
              <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={openMenu}
                onClose={handleClose}
                MenuListProps={{
                  'aria-labelledby': 'basic-button',
                }}
              >
                {/* <MenuItem 
                  onClick={handleClose} 
                  component={Link} 
                  to="/basic-3d-example"
                >
                  Basic 3d example
                </MenuItem> */}
                <MenuItem 
                  onClick={handleClose}
                  component={Link} 
                  to="/3d-world"  
                >
                  Rotating cubes
                </MenuItem>
                <MenuItem 
                  onClick={handleClose}
                  component={Link} 
                  to="/sparks"  
                >
                  Sparks
                </MenuItem>
                {/* <MenuItem onClick={handleClose}>Logout</MenuItem> */}
              </Menu>
          
          </div>
          {facebookNav}

        </Toolbar>
      </AppBar>
    )
}
function DropdownMenu() {

  const [activeMenu, setActiveMenu] = useState('main')
  const [menuHeight, setMenuHeight] = useState(null)
  const dropdownRef = useRef(null)

  useEffect(() => {
    setMenuHeight(dropdownRef.current?.firstChild.offsetHeight)
  }, [])

  function calcHeight(el) {
    const height = el.offsetHeight
    setMenuHeight(height)
  }

  function DropdownItem(props) {
    return (
      <a 
        href="#" className="menu-item" 
        onClick={() => props.goToMenu && setActiveMenu(props.goToMenu)}>
        <span className="icon-button">{props.leftIcon}</span>
        {props.children}
        <span className="icon-right">{props.rightIcon}</span>
      </a>
    )
  }

  return (
    <div className="dropdown"
      style={{ height: menuHeight }}
      ref={dropdownRef}
    >
      <CSSTransition
        in={activeMenu === 'main'}
        unmountOnExit
        timeout={500}
        classNames="menu-primary"
        onEnter={calcHeight}
      >
        <div className="menu">
          <DropdownItem
            leftIcon={<ProfileIcon />}
          >
            My profile
          </DropdownItem>
          <DropdownItem
            leftIcon={<CogIcon />}
            rightIcon={<ChevronIcon />}
            goToMenu="settings"
          >
            Settings
          </DropdownItem>
          <DropdownItem
            leftIcon="🦧"
            rightIcon={<ChevronIcon />}
            goToMenu="animals">
            Animals
          </DropdownItem>
        </div>
      </CSSTransition>

      <CSSTransition
        in={activeMenu === 'settings'}
        timeout={500}
        classNames="menu-secondary"
        unmountOnExit
        onEnter={calcHeight}>
        <div className="menu">
          <DropdownItem goToMenu="main" leftIcon={<ArrowIcon />}>
            <h2>My Name is Adriel</h2>
            {/* <p>  </p>
            <p> /</p> */}
          </DropdownItem>
          <DropdownItem leftIcon={<BoltIcon />}>I love Software and Web Development</DropdownItem>
          <DropdownItem leftIcon={<BoltIcon />}>This project I´ve built using React.js</DropdownItem>
          <DropdownItem leftIcon={<BoltIcon />}>It´s a Single Page Application Architecture WebApp</DropdownItem>
          <DropdownItem leftIcon={<BoltIcon />}>HTML</DropdownItem>
          <DropdownItem leftIcon={<BoltIcon />}>CSS</DropdownItem>
          <DropdownItem leftIcon={<BoltIcon />}>JavaScript</DropdownItem>
          <DropdownItem leftIcon={<BoltIcon />}>
            <a href="https://adriel-portf.web.app/">
              This is my personal portfolio website
            </a>
          </DropdownItem>
        </div>
      </CSSTransition>

      <CSSTransition
        in={activeMenu === 'animals'}
        unmountOnExit
        timeout={500}
        classNames="menu-secondary"
        onEnter={calcHeight}
      >
        <div className="menu">
          <DropdownItem goToMenu="main" leftIcon={<ArrowIcon />}>
            <h2>Animals</h2>
          </DropdownItem>
          <DropdownItem leftIcon="🦘">Kangaroo</DropdownItem>
          <DropdownItem leftIcon="🐸">Frog</DropdownItem>
          <DropdownItem leftIcon="🦋">Horse?</DropdownItem>
          <DropdownItem leftIcon="🦔">Hedgehog</DropdownItem>
        </div>
      </CSSTransition>
    </div>
  )
}


function Navitem(props) {
  
  // console.log(props)

  // const [open, setOpen] = useState(false)

  return (
    <li 
     id={props.id}
     className="nav-item">
      <a href="#" className="icon-button"
        onClick={() => setOpen(!open)}
      >
        {props.icon}
      </a>

      {open && props.children}
    </li>
  )
}

export default Navbar